// extracted by mini-css-extract-plugin
export default {"button-label":"button-label__FtSdp","custom-vars-styles":"custom-vars-styles__G24h5"};